import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './ServiceCarousel.css';

const ServiceCarousel = ({ services }) => {
  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    rtl: true, // For Arabic content
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div className="service-carousel">
      <Slider {...settings}>
        {services.map((service) => (
          <div key={service.id} className="service-slide">
            <div className="service-card">
              <h3>{service.title}</h3>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ServiceCarousel; 